import React, { useState } from 'react';
import 'antd/dist/antd.css';
import PdfIcon from "../../../../assets/pdf.png";
import { Modal, Button, Row, Col, Table, Alert } from 'antd';
import moment from "moment";
import "./customStyle.css";
import { _ } from 'core-js';
import CommonConfig from '../../../commonConfig.json';
import * as actions from '../../../../store/actions/indexes'
import { connect } from 'react-redux';

let clickOrigin = CommonConfig.clickOrigin;

class SignatureDetailsModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            signersList: [],
            // resendResult: {
            //     msgType:,
            //     message:,
            // },
            resendLoading: false,
        };
    }

    getCellType = (key) => {
        return CommonConfig.cellType[key] || 'TEXT';
    }

    // Show = () => {
    //     this.setState({
    //         visible: true,
    //     });
    // }

    hide = async () => {
        await this.props.resendStateClear();
        this.props.toggleSignatureModalVisibility();

    };


    resend = async () => {
        this.setState({ resendLoading: true }, async () => {
            let notSignedSignerOrGroupId = [];
            // if preStepSign NOT_COMPLETED => get initial step not signed signer/group id list
            let preStepSignNotCompleted = this.state.signersList.filter((signer) => {
                return signer.step == 1 && signer.signed == false
            })
            if (preStepSignNotCompleted.length > 0) {
                for (const row of preStepSignNotCompleted) {
                    if (row.groupId != undefined) {
                        notSignedSignerOrGroupId.push(row.groupId);
                    } else {
                        notSignedSignerOrGroupId.push(row.signerId);
                    }
                }
            } else {
                for (const row of this.state.signersList) {
                    if (row.signed == false) {
                        if (row.groupId != undefined) {
                            notSignedSignerOrGroupId.push(row.groupId);
                        } else {
                            notSignedSignerOrGroupId.push(row.signerId);
                        }
                    }
                }
            }

            // this.hide();
            let requestData = {
                envelopRequestId: this.props.signContnent.token,
                appType: this.props.signContnent.appType,
                signerOrGroupId: notSignedSignerOrGroupId,
                hmg: this.props.basicCellData.hmg,
                hotelEnv: this.props.basicCellData.hotelEnv,
                vendor : this.props.signContnent.vendor
            }

            await this.props.resendEnvelopToNotSigned(requestData);
            this.setState({ resendLoading: false })
        });

    }

    timestampColumns = [
        {
            title: 'Signers',
            dataIndex: 'signers',
            key: 'signers',
            width: "110px",
            render: (text, row, index) => {
                if (row.groupId != undefined) {
                    return {
                        children: row.name,
                        props: {
                            rowSpan: row.span,
                        },
                    };
                } else {
                    return row.name
                }
            }
        },
        {
            title: 'Sent',
            dataIndex: 'sentDate',
            key: 'sentDate',
            width: "100px",
            render: (text, row, index) => {
                return (row.sentDate || row.signer.sentDate)
            }
        },
        // {
        //     title: 'Viewed',
        //     dataIndex: 'viewedDate',
        //     key: 'viewedDate',
        //     render: (text, row, index) => {
        //         return (row.viewedDate || row.signer.viewedDate)
        //     }
        // },
        {
            title: 'Signed',
            dataIndex: 'signedDate',
            key: 'signedDate',
            width: "100px",
            render: (text, row, index) => {
                return (row.signedDate || row.signer.signedDate)
            }
        },
        {
            title: 'Completed',
            dataIndex: 'envelopeCompletedDate',
            key: 'envelopeCompletedDate',
            width: "110px",
            render: (text, row, index) => {
                return row.envelopeCompletedDate
            }
        },
        {
            title: 'Email',
            dataIndex: 'signersEmail',
            key: 'signersEmail',
            width: "110px",
            render: (text, row, index) => {
                if (row.groupId != undefined) {
                    return row.signer._envelopeEmail;
                } else {
                    return row._envelopeEmail;
                }
            }
        },
        {
            title: 'Individual Status',
            dataIndex: 'individualStatus',
            key: 'individualStatus',
            width: "110px",
            render: (text, row, index) => {
                let indStat = false;
                if (row.groupId != undefined) {
                    indStat = row.signer.signed;
                } else {
                    indStat = row.signed;
                }
                return (indStat ? (<span className="sign_completed">Signed</span>) : (<span className="sign_pending">Not Signed</span>));
            }
        },
        {
            title: 'Final Status',
            dataIndex: 'finalStatus',
            key: 'finalStatus',
            width: "110px",
            render: (text, row, index) => {
                if (row.groupId != undefined) {
                    return {
                        children: (row.signed ? (<span className="sign_completed">Completed</span>) : (<span className="sign_pending"> Not Completed</span>)),
                        props: {
                            rowSpan: row.span,
                        },
                    };
                } else {
                    return (row.signed ? (<span className="sign_completed">Completed</span>) : (<span className="sign_pending"> Not Completed</span>));
                }
            }
        }
    ]

    certifyColumns = [
        {
            title: 'Group/Individual',
            dataIndex: 'signers',
            key: 'signers',
            width: "110px",
            render: (text, row, index) => {
                if (row.groupId != undefined) {
                    return {
                        children: row.name,
                        props: {
                            rowSpan: row.span,
                        },
                    };
                } else {
                    return row.name
                }
            }
        },
        {
            title: 'Email',
            dataIndex: 'signersEmail',
            key: 'signersEmail',
            width: "110px",
            render: (text, row, index) => {
                if (row.groupId != undefined) {
                    return row.signer._envelopeEmail;
                } else {
                    return row._envelopeEmail;
                }
            }
        },
        {
            title: 'Individual Status',
            dataIndex: 'individualStatus',
            key: 'individualStatus',
            width: "110px",
            render: (text, row, index) => {
                let indStat = false;
                if (row.groupId != undefined) {
                    indStat = row.signer.signed;
                } else {
                    indStat = row.signed;
                }
                return (indStat ? (<span className="sign_completed">Signed</span>) : (<span className="sign_pending">Not Signed</span>));
            }
        },
        {
            title: 'Final Status',
            dataIndex: 'finalStatus',
            key: 'finalStatus',
            width: "110px",
            render: (text, row, index) => {
                if (row.groupId != undefined) {
                    return {
                        children: (row.signed ? (<span className="sign_completed">Completed</span>) : (<span className="sign_pending"> Not Completed</span>)),
                        props: {
                            rowSpan: row.span,
                        },
                    };
                } else {
                    return (row.signed ? (<span className="sign_completed">Completed</span>) : (<span className="sign_pending"> Not Completed</span>));
                }
            }
        }
    ]

    render() {

        let columns = (this.props.compSignatureTimestamp ? this.timestampColumns : this.certifyColumns)
        if(this.props.visible){
            console.log('this.props at modal',this.props);
            let isSignersGroup = this.props.signContnent.groups.length !== 0 ? true : false;
            let temp_signers = isSignersGroup ? [...this.props.signContnent.groups, ...this.props.signContnent.signers] : this.props.signContnent.signers;
            let accumulated_list = temp_signers.map(i => i);
            let createdDate = moment(this.props.signContnent.createdDate).format('LLL');
            this.state.signersList = accumulated_list;
            this.state.createdDate = createdDate;

            let data = [];
            let step1 = 0;
            let modalData = "";
            let signatureCertificate = "";
            let appendedEnvInfo = {
                message: "",
                type:""
            };
            let modalFooterBtn = ([
                <Button key="signModalOK" type="button" className="signModalsubmitBtn" onClick={this.hide}>
                    Ok
                </Button>,
                (!['PARTIAL_SIGN', 'NOT_SIGNED','EXPIRED'].includes(this.getCellType(this.props.signStatus.type))?(
                    <Button key="signModalResend" type="primary" className="signModalsubmitBtn" onClick={this.resend} loading={this.state.resendLoading}>
                        Resend
                    </Button>
                ):(
                    ""
                ))
            ]);

            if(!moment(this.props.basicCellData.bdate,"MM-DD-YYYY").isSame(moment(this.props.signContnent.envelopeDate,"YYYY-MM-DD"))){
                if(this.props.signStatus.signCompleted !== undefined 
                    && this.props.signStatus.signCompleted === true){ //completed envelop
                        appendedEnvInfo.message = "Completed signature of appended  envelope - " +moment(this.props.signContnent.envelopeDate,"YYYY-MM-DD").format("MM-DD-YYYY");
                        appendedEnvInfo.type = "success";
                        //Completed Signature of (appended business date) envelope
                    } else { // pending envelop
                        appendedEnvInfo.message = "Pending signature of appended  envelope - " + moment(this.props.signContnent.envelopeDate,"YYYY-MM-DD").format("MM-DD-YYYY");
                        appendedEnvInfo.type = "warning";
                        // Pending Signature of (appended business date) envelope
                    }
            }
            // show the signature drill down if cell type is pending review
            if (this.props.origin === clickOrigin.RATIO || 
                ['PENDING_REVIEW', 'PARTIAL_SIGN', 'NOT_SIGNED'].includes(this.getCellType(this.props.signStatus.type)) 
                || ( ['TEXT'].includes(this.getCellType(this.props.signStatus.type)) 
                    && this.props.signStatus.signCompleted !== undefined 
                    && this.props.signStatus.signCompleted == true) ) {

                for (const row of this.state.signersList) {
                    row.envelopeCompletedDate = this.props.envelopeCompletedDate;

                    if (row.groupId != undefined) {
                        let groupSigned = -1;

                        let subData = [];
                        for (let x = 0; x < row.signers.length; x++) {
                            if (groupSigned === -1 && row.signers[x].signed) {
                                groupSigned = x;
                            }
                            let newRow = { ...row }
                            newRow.span = (x === 0 ? row.signers.length : 0);
                            newRow.signer = row.signers[x];
                            delete newRow.signers;
                            subData.push(newRow);

                            //step calculation
                            if (newRow.step === 1) {
                                step1 += 1;
                            }
                        }

                        // if (groupSigned !== -1 && subData.length > 1) {
                        //     for (let x = 0; x < subData.length; x++) {
                        //         if (x !== groupSigned) {
                        //             subData[x].signer.signedDate = "-";
                        //         }
                        //     }
                        // }

                        // if (groupSigned === -1) {
                        //     for (let x = 0; x < subData.length; x++) {
                        //         subData[x].signer.signedDate = "";
                        //     }
                        // }

                        data = data.concat(subData);
                    } else {
                        if (row.step === 1) {
                            step1 += 1;
                        }
                        data.push(row);
                    }
                };

                data.sort((a, b) => {
                    if (a.step > b.step) {
                        return 1;
                    }
                    if (a.step < b.step) {
                        return -1;
                    }
                    if (a.name > b.name) {
                        return 1;
                    }
                    if (a.name < b.name) {
                        return -1;
                    }
                    if (a.span < b.span) {
                        return 1;
                    }
                    if (a.span > b.span) {
                        return -1;
                    }
                });
                // console.log("SIG :::", data)

                if (data.length > 1) {
                    for (let x = 0; x < data.length; x++) {
                        if (x === 0) {
                            data[x].stepSpan = step1;
                        } else if (x < step1 || x > step1) {
                            data[x].stepSpan = 0;
                        } else if (x === step1) {
                            data[x].stepSpan = (data.length - step1);
                        }
                    }
                }

                if ((step1 < data.length) && (columns[0].title !== 'Step')) {
                    columns = [
                        {
                            title: 'Step',
                            dataIndex: 'step',
                            key: 'step',
                            width: '10%',
                            render: (text, row, index) => {
                                return {
                                    children: "Step " + row.step,
                                    props: {
                                        rowSpan: row.stepSpan,
                                    },
                                };
                            }
                        }
                    ].concat(columns);
                }

                if (this.props.signStatus.signaturePermission) {
                    // enabling signature certificate => if signature completed and have user access to show certificate
                    if (['TEXT'].includes(this.getCellType(this.props.signStatus.type))
                        && (this.props.signStatus.signCompleted !== undefined && this.props.signStatus.signCompleted)
                        && (this.props.compSignCertShowHide)) {
                        signatureCertificate = (
                            <Row justify="end">
                                <Col>
                                    <a href={this.props.signStatus.link !== undefined && this.props.signStatus.link != null ? this.props.signStatus.link : "#"} target="_blank" className="signatureCertLink" >
                                        <img src={PdfIcon} />
                                        Signature Certificate
                                    </a>
                                </Col>
                            </Row>
                        );
                    }
                }

                // enabling resend option => remove when signature completed
                if ((['TEXT'].includes(this.getCellType(this.props.signStatus.type)) && this.props.signStatus.signCompleted !== undefined && this.props.signStatus.signCompleted == true)) {
                    modalFooterBtn = ([
                        <Button key="signModalOK" type="primary" className="signModalsubmitBtn" onClick={this.hide}>
                            Ok
                        </Button>
                    ]);
                }

                modalData = (
                    <>
                        {(appendedEnvInfo.message !== "") ?
                            (<Alert message={appendedEnvInfo.message} type={appendedEnvInfo.type}></Alert>) :
                            ("")
                        }
                        <br/>
                        <Table
                            id="sigDataTab"
                            columns={columns}
                            dataSource={data}
                            pagination={false}
                            scroll={{ y: 300 }}
                        />
                        {signatureCertificate}
                    </>
                );

            } else if (this.props.origin === clickOrigin.BUTTON || ['SIGN'].includes(this.getCellType(this.props.signStatus.type))) {
                modalData = (
                    <Row justify='center' style={{ fontSize: '16', textAlign: 'center' }}>
                        <Col>
                            Please Check the email sent to <span style={{ fontWeight: '600' }}>{this.props.userEmail}</span> with the subject <span style={{ fontWeight: '600' }}>{this.props.signContnent.subject}</span> and review.
                        </Col>
                    </Row>
                );
            }

            return (
                <div className="signatureModal">
                    <Modal
                        title={"Signature Details - " + this.props.basicCellData.bdate}
                        centered
                        // visible={this.state.visible}
                        visible={this.props.visible}
                        onCancel={this.hide}
                        width={(['SIGN'].includes(this.getCellType(this.props.signStatus.type)) && this.props.origin === clickOrigin.BUTTON) ? 650 : 1150}
                        className={['SIGN'].includes(this.getCellType(this.props.signStatus.type)) ? "signPending" : "signDetails"}
                        footer={[
                            <Row gutter={[8, 8]}>
                                <Col>
                                    {modalFooterBtn}
                                </Col>
                            </Row>
                        ]}
                    >
                        <Row gutter={[8, 8]}>
                            <Col>
                                {modalData}
                            </Col>
                        </Row>
                        <Row gutter={[8, 8]} style={{ display: this.props.envelopResendState.stateShow ? 'block' : 'none' }}>
                            <Col>
                                <Alert 
                                    type={this.props.envelopResendState.stateType} 
                                    message={this.props.envelopResendState.stateMessage} 
                                    showIcon 
                                    style={{textAlign:'center'}} />
                            </Col>
                        </Row>
                    </Modal>
                </div>
            );
        }else{
            return(<></>)

        }
        
    }
}

const mapStateToProps = (state) => {
    // console.log("NEW PROPS",state.signatureDetailsPopupReducer.sigPopupDetails)
    return {
        userEmail: state.userDetailReducer.userEmail,
        compSignCertShowHide: state.appPermissionsReducer.compliancePermissions.compSignCertShowHide,
        envelopResendState: state.signatureApp.envelopResendState,
        
        signContnent : state.signatureDetailsPopupReducer.sigPopupDetails.signContnent,
        signStatus : state.signatureDetailsPopupReducer.sigPopupDetails.signStatus,
        basicCellData : state.signatureDetailsPopupReducer.sigPopupDetails.basicCellData,
        onHide : state.signatureDetailsPopupReducer.sigPopupDetails.onHide,
        visible : state.signatureDetailsPopupReducer.sigPopupVisibility,
        origin : state.signatureDetailsPopupReducer.sigPopupDetails.origin,

        envelopeSentDate : state.signatureDetailsPopupReducer.sigPopupDetails.signContnent.envelopeSentDate,
        envelopeCompletedDate : state.signatureDetailsPopupReducer.sigPopupDetails.signContnent.envelopeCompletedDate,
        
        compSignatureTimestamp: state.appPermissionsReducer.compliancePermissions.compSignatureTimestamp
    }
}

const mapDispatchToProps = (dispatch) => ({
    resendEnvelopToNotSigned: (params) => dispatch(actions.resendEnvelopToNotSigned(params)),
    resendStateClear: () => dispatch(actions.resendStateClear()),
    toggleSignatureModalVisibility: () => dispatch(actions.toggleSignatureModalVisibility())

})

export default connect(mapStateToProps, mapDispatchToProps)(SignatureDetailsModal);